import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
	static targets = ["select", "customValueTemplate", "customValueContainer"];

	connect() {
		this.handle({ target: this.selectTarget });
	}

	handle(event) {
		let selectedOption = event.target.options[event.target.selectedIndex];

		if (!selectedOption.dataset.value) {
			this.customValueContainerTarget.innerHTML =
				this.customValueTemplateTarget.innerHTML;
			this.customValueContainerTarget.classList.remove("hidden");
		} else {
			this.customValueContainerTarget.innerHTML = "";
			this.customValueContainerTarget.classList.add("hidden");
		}
	}
}
